
<template>
  <div class="tableHolder" >
    <vxe-table
        border
        show-overflow
        ref="vxeTable"
        height="100%"
        class="mytable-style"
        :row-class-name="rowClassName"
        :header-cell-class-name="headerCellClassName"
        :cell-style="{height:90,padding:0,margin:0}"
        :data = "tableData"
        :row-config="{isHover: true}"
        :tooltip-config="{showAll:false,enterable: false, contentMethod: ()=>{return ''}}"
        :sort-config="{trigger: 'cell'}">
      <vxe-column field="name" fixed="left" width="80">
        <template #header>
          <div style="font-weight: bold;font-size: 16px;text-align: center;width: 100%">{{"姓名"}}</div>
        </template>
        <template #default="{row}">
            <div style="text-align: center;font-weight:bold;color:#000000;font-size:18px;" >
              {{row.player_name}}
            </div>
        </template>
      </vxe-column>
        <vxe-column v-for="(column,index) in gameList" :field="`game-${index}`" :key="`game-${index}`" width="201">
          <template #header>
            <div v-if="gameList[index].has_score || isFutureDate(...gameList[index].end_date)" style="font-size: 16px;text-align: center;width:100%;font-weight: bold">{{`${gameList[index].match_name}`}}</div>
            <div v-else-if="$store.state.editMode" style="font-size: 16px;text-align: center;width:100%;font-weight: lighter;color: #BF936B">{{`${gameList[index].match_name}`}}</div>
            <div v-else style="font-size: 16px;text-align: center;width:100%;font-weight: bold">{{`${gameList[index].match_name}`}}</div>

            <div  style="width:100%;font-size: 12px">地点：{{gameList[index].location}}</div>
            <div  style="width:100%;font-size: 12px">时间：{{getDateName(gameList[index].start_date,gameList[index].end_date)}}</div>
            <div v-if="isCurrentTeamMix" style="display: flex;text-align: center">
              <a-tooltip placement="bottom">
                <template #title>混双</template>
              <div style="background-color:#bf936b;margin-top: 2px;margin-bottom: 0;
              margin-left: 67.5px;margin-right: 67.5px;
              width: 45px;height: 25px;line-height: 25px">
                {{gameListSum[index][3]}}</div>
              </a-tooltip>
            </div>
            <div v-else style="display: flex;text-align: center">
              <a-tooltip placement="bottom"   >
                <template #title>单打</template>
                <div style="background-color:#0072be;margin-top: 2px;margin-bottom: 0;
              width: 45px;height: 25px;line-height: 25px">
                  {{gameListSum[index][0]}}</div>
              </a-tooltip>
              <a-tooltip placement="bottom">
                <template #title>双打</template>
              <div style="background-color:#9364c2;margin-top: 2px;margin-bottom: 0;
              width: 45px;height: 25px;line-height: 25px">
                {{gameListSum[index][1]}}</div>
                </a-tooltip>
              <a-tooltip placement="bottom">
                <template #title>团体</template>
              <div style="background-color:#00a5af;margin-top: 2px;margin-bottom: 0;
              width: 45px;height: 25px;line-height: 25px">
                {{gameListSum[index][2]}}</div>
              </a-tooltip>
              <a-tooltip placement="bottom">
                <template #title>混双</template>
              <div style="background-color:#bf936b;margin-top: 2px;margin-bottom: 0;
              width: 45px;height: 25px;line-height: 25px">
                {{gameListSum[index][3]}}</div>
              </a-tooltip>
            </div>
          </template>
          <template #default="{row}">
            <div >
              <TypeSelect :values="{
                playerId: row.player_id,
                player_eng_name: row.player_eng_name,
                player_name:row.player_name,
                gender:row.gender,
                competitionId:row.comp[index].match_id ,
                single: row.comp[index].single,
                double: row.comp[index].double,
                has_score: (!$store.state.editMode) && row.comp[index].has_score,
                has_archived: row.comp[index].has_archived,
                team: row.comp[index].team,
                mixed: row.comp[index].mixed,
                mixedPartnerName: row.comp[index].mixed_partner_name?row.comp[index].mixed_partner_name:'',
                doublePartnerName: row.comp[index].double_partner_name?row.comp[index].double_partner_name:'',
                mixedPartner: row.comp[index].mixed_partner_id?row.comp[index].mixed_partner_id:'',
                doublePartner: row.comp[index].double_partner_id?row.comp[index].double_partner_id:'',
                colId: index,
              }" :bfvalue="row" @changeTypeValue="(data)=>{
                changeTypeValue(data,row.key,index)}"/>
            </div>
          </template>
        </vxe-column>
      <vxe-column v-for="(i) in [1,2,3,4]" :field="`sum${i}Title`" :key="`sum${i}Title`" fixed="right" width="89">
        <template #header >
          <span style="font-weight: bold;font-size: 16px;width:100%;text-align: center;">
            {{sumTitleName[judgeGender[currentTeam?currentTeam:'mixed']][i-1]}}
          </span>
        </template>
        <template #default="{row}">
          <div v-if="isCurrentTeamMix && i!==4"></div>
          <StatisticBars v-else :values="{
                  playerId: row.player_id,
                  gender:row.gender,
                  max:maxNum,
                  ...row.sum[i-1]
              }"/>
        </template>
      </vxe-column>
    </vxe-table>
    <HybridSelectFilterOption
        :isVisible="mixedSelect.visible"
        :selectInfo="mixedSelect"
        @changeMixedPartner="changeMixedPartner" />
    <HybridSelectFilterOption
        :isVisible="doubleSelect.visible"
        :selectInfo="doubleSelect"
        @changeMixedPartner="changeDoublePartner" />
  </div>

</template>
<script>
import {defineComponent} from 'vue';
import UnitSample from "@/components/table/UnitSample";
import TypeSelect from "@/components/table/TypeSelect.vue";
import StatisticBars from "@/components/table/StatisticBars.vue";
import HybridSelectFilterOption from "@/components/table/HybridSelectModel.vue"
import {getPlayerPartner,  updatePlayerParticipationInOneMatch} from "@/api";
import {message} from "ant-design-vue";


// const color_custom=['#0072be','#9364c2','#00a5af','#bf936b']
// const cellPadding = 0;
// const headerPadding = 4;
export default defineComponent({
  components: {
    UnitSample,
    TypeSelect,
    StatisticBars,
    HybridSelectFilterOption,
  },
  props: {
    "values": {
      type: Object,
      default: null,
    }
  },
  computed: {
    isCurrentTeamMix() {
      return ['mixed', 'youth_mixed'].includes(this.$store.state.currentTeam)
    },
    gameListSum1(){
      if(this.gameList && this.gameList.length>0){
        return this.gameList.map((r,idx)=>{
          let sum = [0,0,0,0]
          // console.log(r)
          for(let i_player=0;i_player<this.playerList.length;i_player++){
            if(this.tableData[i_player].comp[idx]["single"])sum[0]++;
            if(this.tableData[i_player].comp[idx]["double"])sum[1]++;
            if(this.tableData[i_player].comp[idx]["team"])sum[2]++;
            if(this.tableData[i_player].comp[idx]["mixed"])sum[3]++;
          }
          // console.log(r,sum)
          return sum})
      }else{
        return null
      }
    }
  },
  data() {
    return {
      calWinHeight:Math.floor(screen.height * 0.75),
      tableData:this.values.tableData,
      maxNum:this.values.maxQ,
      gameList:this.values.competitions,
      gameListSum:null,
      // customGameTitleList:[],
      currentTeam:this.values.currentTeam,
      judgeGender:{
        "men":0,"women":1,"youth_men":0,"youth_women":1,"mixed":2,"youth_mixed":2
      },
      playerList: this.values.playerList,
      tableHolderClass:'tableHolder',
      sumTitleName:[["男单合计","男双合计","团体合计","混双合计"],["女单合计","女双合计","团体合计","混双合计"],["单打合计","双打合计","团体合计","混双合计"]],
      mixedSelect: {
        idx:0,
        playerId: 0,
        competitionId: 0,
        playerList: [],
        visible: false,
      },
      doubleSelect: {
        idx:0,
        playerId: 0,
        competitionId: 0,
        playerList: [],
        visible: false,
      },
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    values: { // 对对象进行深度监听
      handler(value) {
        if(value) {
          this.tableData=value.tableData
          this.gameList=value.competitions
          this.playerList= value.playerList
          this.currentTeam = value.currentTeam
          this.maxNum = value.maxQ
          this.gameListSum = this.gameList.map((r,idx)=>{
            let sum = [0,0,0,0]
            // console.log(r)
            for(let i_player=0;i_player<this.playerList.length;i_player++){
              if(this.tableData[i_player].comp[idx]["single"])sum[0]++;
              if(this.tableData[i_player].comp[idx]["double"])sum[1]++;
              if(this.tableData[i_player].comp[idx]["team"])sum[2]++;
              if(this.tableData[i_player].comp[idx]["mixed"])sum[3]++;
            }
            // console.log(r,sum)
            return sum})
          // this.maxNum = this.maxNum < 0? value.maxQ : this.maxNum
          // console.log("values",value)
          // this.setTitleByMatchList()
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods:{
    init(){
      const slider = document.querySelector("thead tr");
      const body = document.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper");
      // console.log(slider,body)
      let isDown = false;
      let startX;
      let scrollLeft;
      if(slider && body){
        slider.addEventListener("mousedown", (e) => {
          isDown = true;
          slider.classList.add("active");
          startX = e.pageX - body.offsetLeft;
          scrollLeft = body.scrollLeft;
        });
        // slider.addEventListener("mouseleave", () => {
        //   isDown = false;
        //   slider.classList.remove("active");
        // });
        slider.addEventListener("mouseup", () => {
          isDown = false;
          slider.classList.remove("active");
        });
        body.addEventListener("mouseup", () => {
          isDown = false;
          slider.classList.remove("active");
        });
        slider.addEventListener("mousemove", (e) => {
          // console.log("es",e,isDown)
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - body.offsetLeft;
          const walk = (x - startX); // * 3 when need scroll-fast
          body.scrollLeft = scrollLeft - walk;
        });
        body.addEventListener("mousemove", (e) => {
          // console.log("ev",e,isDown)
          if (!isDown) return;

          e.preventDefault();
          const x = e.pageX - body.offsetLeft;
          const walk = (x - startX); // * 3 when need scroll-fast
          body.scrollLeft = scrollLeft - walk;
        });
      }
    },

    isFutureDate(y,m,d){
      let thisDay = new Date(y,m,d)
      let today = new Date()
      // console.log(thisDay,today,thisDay<today)
      return thisDay > today
    },
    changeTypeValue(data,playerIdx,index) {
      // console.log(playerIdx,this.tableData)
      // 设置对应的成员、比赛的数据，这里以this.example举例
      let cellData = this.tableData[playerIdx].comp[index];
      let partner_id = ''
      let shouldPostHere = true
      if(!['mixed', 'double'].includes(data.type)) {
        cellData[data.type] = data.value

      } else if(data.type==='mixed' && data.value === true) {
        // 处理要传给Mixed Select的信息并且开启Model
        // if(!this.loading)this.loading = true
        this.$store.commit('setLoading',true)
        this.getPartnerList(data.playerId,'mixed').then(
            (plist)=>{
              this.mixedSelect.playerList=plist
              this.mixedSelect.playerList.push({"player_id":"-2","player_name":"其他"})
              this.mixedSelect.playerId = data.playerId
              this.mixedSelect.competitionId = data.competitionId
              this.mixedSelect.visible = true
              this.mixedSelect.idx = playerIdx
            }
        )
        shouldPostHere = false
      } else if(data.type==='mixed' &&data.value === false){
        this.mixedSelect.playerId = data.playerId
        this.mixedSelect.competitionId = data.competitionId
        this.mixedSelect.idx = playerIdx
        cellData.mixed_partner_id = ''
        partner_id = ''
        cellData.mixed = false
        this.mixedSelect.visible = false
      }else if(data.type==='double' && data.value === true) {
        // 处理要传给Mixed Select的信息并且开启Model
        // this.playerList = ...
        // if(!this.loading)this.loading = true
        this.$store.commit('setLoading',true)
        this.getPartnerList(data.playerId,'double').then(
            (plist)=>{
              this.doubleSelect.playerList = plist
              this.doubleSelect.playerList.push({"player_id":"-2","player_name":"其他"})
              this.doubleSelect.playerId = data.playerId
              this.doubleSelect.competitionId = data.competitionId
              this.doubleSelect.visible = true
              this.doubleSelect.idx = playerIdx
            }
        )
        shouldPostHere = false
      } else if(data.type==='double' &&data.value === false){
        this.doubleSelect.playerId = data.playerId
        this.doubleSelect.competitionId = data.competitionId
        this.doubleSelect.idx = playerIdx
        cellData.double_partner_id = ''
        partner_id = ''
        cellData.double = false
        this.doubleSelect.visible = false
      }
      if(shouldPostHere){
        // if(!this.loading)this.loading = true
        this.$store.commit('setLoading',true)
        this.updatePlayerParticipation(data.playerId,
            cellData.match_id,  data.type,
            data.value, partner_id,playerIdx
        )
      }
    },
    async getPartnerList(player_id,type){
      const response = await getPlayerPartner(player_id,type)
      if(response.status === 200){
        return response.data.players
      }else{
        message.error('net error')
        return []
      }
    },
    async updatePlayerParticipation(playerId,match_id,competition_type,selected,partner_id,playerIdx){
      const postData = {
        match_id:match_id,
        competition_type:competition_type,
        selected:selected,
        partner_id:partner_id
      }
      const response = await updatePlayerParticipationInOneMatch(playerId,{data:postData})
      if (response.status === 200) {
        console.log("aft change",playerIdx,response.data.changed_participation)
        this.updateTableDataChanged(this.playerList,this.gameList,response.data.changed_participation)
        // this.$emit('reFetchLoadingRender')
        // this.tableData[playerIdx].comp[match_id] = response.data.changed_participation
        // this.$emit('controlLoading',{'loading':false})
        // message.success('update success')
      }else{
        message.error("conflict")
        //end loading
      }
      // if(this.loading)this.loading=false
      this.$store.commit('setLoading',false)
    },

    updateTableDataChanged(plist,matchlist,changedList) {
      const gameType = ['single','double','team','mixed']
      let table=this.tableData
      for(let i=0;i<changedList.length;i++){
        let player_id = changedList[i].player_id
        if(player_id.length===0)continue
        let match_id = changedList[i].match_id
        let idx_p =-1,idx_m=-1;
        for( let j=0;j<plist.length;j++) {
          if(plist[j].player_id===player_id){
            idx_p=j;
          }
        }
        for( let j=0;j<matchlist.length;j++) {
          if(matchlist[j].match_id===match_id){
            idx_m=j;
          }
        }
        if(idx_p===-1 || idx_m ===-1)continue
        let row = table[idx_p]
        row.comp[idx_m] = {
          quarter: Math.floor((matchlist[idx_m].start_date[1]-1) / 3),
          has_score:matchlist[idx_m].has_score,
          has_archived:matchlist[idx_m].has_archived,
          ...changedList[i]
        }
        let sum = []
        //计算这个人的数据，看看是否更新maxQ
        for(let j=0;j<4;j++) {
          let total = 0
          let type_ = gameType[j];
          let details = [0, 0, 0, 0]
          for (let k=0;k<matchlist.length;k++){
            if(row.comp[k][type_]){
              details[row.comp[k]['quarter']]+=1;
            }
            total += (row.comp[k][type_] ? 1 : 0)
          }
          sum.push({
            type: type_,
            total: total,
            details: details
          })
        }
        row.sum = sum
        table[idx_p]=row
      }
      // 直接重新计算全体球员
      let newMax = 0
      console.log(table)
      for(let i=0;i<plist.length;i++){
        for(let j=0;j<4;j++) {
          // let type_ = gameType[j];
          if(newMax < Math.max(...(table[i].sum[j].details))){
            newMax = Math.max(...(table[i].sum[j].details))
          }

        }
      }
      this.maxNum = newMax
      // 还是要重新计算一次，只是少了网络时间，以及更新的话只更新部分？还是所有人更新，因为有个max
      this.tableData = table;

      this.gameListSum = this.gameList.map((r,idx)=>{
        let sum = [0,0,0,0]
        for(let i_player=0;i_player<this.playerList.length;i_player++){
          if(this.tableData[i_player].comp[idx]["single"])sum[0]++;
          if(this.tableData[i_player].comp[idx]["double"])sum[1]++;
          if(this.tableData[i_player].comp[idx]["team"])sum[2]++;
          if(this.tableData[i_player].comp[idx]["mixed"])sum[3]++;
        }
        // console.log(r,sum)
        return sum})

      console.log(table[0], this.maxNum)
      this.$refs.vxeTable.loadData(table)
      // if(this.loading)this.loading=false
      this.$store.commit('setLoading',false)
      return table;
    },
    headerCellClassName ({ column }) {
      if (column.property === 'sum1Title') {
        return 'col-blue'
      }else if(column.property === 'sum2Title'){
        return 'col-purple'
      }else if(column.property === 'sum3Title'){
        return 'col-green'
      }else if(column.property === 'sum4Title'){
        return 'col-yellow'
      }else{
        return 'col-default'
      }
    },
    rowClassName ({ rowIndex }) {

        return (rowIndex%2===0)?'row-default1':'row-default2'

    },
    changeMixedPartner(data) {
      // if(!this.loading)this.loading = true

      // let cellData = this.tableData[this.mixedSelect.idx].comp[this.mixedSelect.competitionId];
      let dataType = 'mixed'
      this.mixedSelect.visible = false
      console.log('this.mixedSelect.playerId',this.mixedSelect.playerId)
      // 设置对应的成员、比赛的混双数据，这里以this.example举例
      // cellData[`${dataType}_partner_id`] = data.mixedPartner
      // cellData[dataType] = data.mixedPartner.length > 0
      if(data.mixedPartner.length>0){
        this.updatePlayerParticipation(this.mixedSelect.playerId,
            this.mixedSelect.competitionId,  dataType,
            data.mixedPartner.length > 0, data.mixedPartner,this.mixedSelect.idx
        )
      }
    },
    changeDoublePartner(data) {
      // if(!this.loading)this.loading = true
      // this.$store.commit('setLoading',true)
      let dataType = 'double'
      this.doubleSelect.visible = false
      if(data.mixedPartner.length>0){
        this.updatePlayerParticipation(this.doubleSelect.playerId,
            this.doubleSelect.competitionId,  dataType,
            data.mixedPartner.length>0, data.mixedPartner,this.doubleSelect.idx
        )
      }
    },
    getDateName(start,end){
      // return `${start[1]}.${start[2]}-${end[1]}.${end[2]}`
      return `${start[0]}.${start[1]}.${start[2]}-${end[0]}.${end[1]}.${end[2]}`
    }
  },

});
</script>

<!--<style lang="less">-->
<!--/deep/ .ant-tooltip {-->
<!--  background-color: white !important;-->
<!--}-->
<!--/deep/ .ant-tooltip-inner {-->
<!--  background-color: white !important;-->
<!--}-->
<!--</style>-->
<style lang="less" scoped>
.tableHolder{
  padding-top: 2vh;
  height: 85vh;
  margin-left: 30px;
  margin-right: 30px;
}
.body{
  user-select: none
}

/deep/ .mytable-style .vxe-header--column.col-default {
  background-color: #00375b;
  //text-align: center;
  color: #fff;
}
/deep/ .mytable-style .vxe-header--column.col-blue {
  background-color: #0072be;
  color: #fff;
}
/deep/ .mytable-style .vxe-header--column.col-purple {
  background-color: #9364c2;
  color: #fff;
}
/deep/ .mytable-style .vxe-header--column.col-green {
  background-color: #00a5af;
  color: #fff;
}
/deep/ .mytable-style .vxe-header--column.col-yellow {
  background-color: #bf936b;
  color: #fff;
}


/deep/ .vxe-cell{
  max-height: 100px !important;
  overflow: visible !important;
  //padding: 0 !important;
}
/deep/ .mytable-style .vxe-body--row .vxe-cell{
  max-height: 100px !important;
  padding: 0 !important;
}
/deep/ .mytable-style .vxe-body--row.row-default1 {
  height: 90px !important;
  background-color: #ecf6ff;
  padding: 0 !important;
  //color: #fff;
}
/deep/ .mytable-style .vxe-body--row.row-default2 {
  height: 90px !important;
  background-color: #d4e3ef;
  //color: #fff;
}


///deep/ .ant-table-pagination.ant-pagination{
//  background-color: #FFFFFF;
//  position: relative !important;
//  top: -20px !important;
//  z-index: 999 !important;
//}
//
///deep/ .ant-pagination-total-text{
//  height: 20px !important;
//  margin: 10px;
//}


/deep/ .ant-table-header-column{
  width: 100% !important;
}
///deep/ .ant-table-scroll{
//  overflow-y: hidden!important;
//}
///deep/ .ant-table-body{
//  overflow-y: hidden!important;
//}
/deep/ .ant-table-body-inner{
  overflow-y: hidden!important;
}

/deep/ .ant-table-body:hover{
  overflow-y: scroll!important;
}
///deep/ .ant-table-row-cell-break-word{
// padding: 0 !important;
//}

///deep/ .ant-table-body-inner::-webkit-scrollbar {
//  width: 3px;
//  //height: 0.5px;
//}
///deep/ .ant-table-body-inner::-webkit-scrollbar-thumb {
//  border-radius: 10px;
//  background: rgba(0,0,0,1);
//}

///deep/ .ant-table-hide-scrollbar::-webkit-scrollbar {
//
//}



/deep/ .ant-table-body::-webkit-scrollbar {
  width: 3px;
  height: 10px;
}
/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0,0,0,0.4);
}
/deep/ .ant-table-body::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0,0,0,0.2);
}
</style>
